export enum BoardColumnType {
  Unselected = 0,
  Unit = 'Unit',
  Comments = 'Comments',
  PropertyName = 'PropertyName',
  UnitStatus = 'UnitStatus',
  TurnStep = 'TurnStep',
  TurnDescription = 'TurnDescription',
  Notes = 'Notes',
  Documents = 'Documents',

  DropDown = 'DropDown',

  ProjectType = 'ProjectType',

  // == Date ==
  MoveIn = 'MoveIn',
  MoveOut = 'MoveOut',
  Available = 'Available',
  Showable = 'Showable',
  CustomDate = 'CustomDate',

  // == Dollar ==
  NewRent = 'NewRent',
  OldRent = 'OldRent',
  MarketRent = 'MarketRent',
  AdvertisedRent = 'AdvertisedRent',
  CustomAmount = 'CustomAmount',
  UnitTotal = 'UnitTotal',
  Budget = 'Budget',
  Delta = 'Variance',

  // == Info ==
  Assignee = 'Assignee',
  UnitType = 'UnitType',
  NewTenant = 'NewTenant',

  // == Enum ==
  NewFinish = 'NewFinish',
  OldFinish = 'OldFinish',
  Finish = 'Finish',

  // == Schedule ==
  Simple = 'Simple',
  Timed = 'Timed',
  Workorder = 'Workorder',

  // == Time ==
  Days = 'Days', // -- days in current step
  TotalDays = 'TotalDays', // -- days since move-out date

  // Bulk mode
  BulkModeSelectRow = 'BulkModeSelectRow',

  // Applicant
  ApplicantName = 'ApplicantName',
  ApplicantDate = 'ApplicantDate',
  ApplicantStatus = 'ApplicantStatus',
  ApplicantApprovedDate = 'ApplicantApprovedDate',
  ApplicationCompletedDate = 'ApplicationCompletedDate',
  LeaseApprovedDate = 'LeaseApprovedDate',
}

export enum BoardType {
  MakeReady,
  Reno,
  Marketing,
  Custom,
  Eviction,
  MoveOut,
  MoveIn,
  Approval,
  NonPms,
  Prelease,
  LeaseUp,
}

export enum BoardLayoutType {
  TurnoverBoard,
  ProjectsBoard,
}

export enum BoardOutputType {
  SendToApproval,
  SendToLeaseUpOrMoveIn,
  None,
  SendToMoveOut,
  SendToMakeReady,
  SendToPunch,
  SendToReno,
  SendToArchive,
}

export enum BoardOutputBehaviour {
  Manually,
  Automatically,
}

export enum SendBackBehaviour {
  Keep,
  ClearSchedules,
}

export enum TurnTransitBackByTurnFlowBehavior {
  Keep,
  RemoveFromBoard,
}

export enum BoardProgressType {
  None,
  UpdateMakeReadyProgressBar,
  UpdateRENOProgressBar,
  UpdateNoticeProgressBar,
  UpdateMoveInProgressBar,
  UpdateMoveOutProgressBar,
  UpdateApprovalProgressBar,
  UpdateLeaseUpProgressBar,
}

export enum BoardSourceType {
  MakeReadyUnits,
  RenoUnits,
  UnleasedUnits,
  OnNoticeUnits,
  MoveOutUnits,
  MarketingUnits,
  OnNoticeAndUnleasedUnits,
  Manual,
  UnitsInNoticeUnderEviction,
  UnitsInMoveIn,
  UnitsInApproval,
  UnitsInPunch,
  None,
  NonPmsUnits,
  PreleaseUnits,
  LeaseUpUnits,
  UnleasedUnitsNotReady,
  UnleasedUnitsReady,
}

export enum BoardMakeReadySteps {
  TrashOut = 'Trash out',
  Painting = 'Painting',
  Hardware = 'Hardware',
  Flooring = 'Flooring',
  RemoveOldApp = 'Remove old app.',
  InstallNewApp = 'Install new app.',
}

export enum ScheduleCellStatus {
  Due,
  Skipped,
  Done,
  Late,
  Unscheduled,
  Pending,
  Declined,
  Started,
  Moved,
  StartedLate,
  StartedMoved,
  Review,
}

export enum ScheduleCellMenuActions {
  DONE = 'Done',
  STARTED = 'Started',
  PENDING = 'Pending',
  RESCHEDULE = 'Reschedule',
  SCHEDULE = 'Schedule',
  SKIPPED = 'Skipped',
  CLEAR = 'Clear',
  VIEW_INSPECTION = 'View Inspection',
  EDIT_TEMPLATE = 'Edit template',
  EDIT_TEMPLATE_ASSOCIATION = 'Edit template association',
  UPDATE_AMOUNT = 'Update Amount',
  ENTER_AMOUNT = 'Enter Amount',
  MARK_AS_ESTIMATED = 'Mark as Estimated',
  MARK_AS_FINAL = 'Mark as Final',
  MARK_AS_UNPAID = 'Mark as Unpaid',
  MARK_AS_PAID = 'Mark as Paid',
  MARK_ALL_AS_DONE = 'Mark all as done',
  VIEW_TICKET = 'View Ticket',
  GO_BOARD = 'Go to board',
  GO_TURNOVER = 'Go to turnover',
  GO_UNIT = 'Go to unit',
}

export enum StartedSubType {
  StartedLate,
  StartedMoved,
}

export enum ScheduleCellColor {
  Done = 0, // $tpp-green11
  MoveOut = 1, // $tpp-orange8
  Due = 2, // $tpp-purple
  Review = 5,
  Started = 6, // $tpp-orange6
  StartedLate = 11,
  StartedMoved = 12,
  Expired = 13,
}

export enum BoardView {
  Unit,
  Calendar,
}
